import SEOService from "../../Services/SEO.service";
let cachedInstitutionPromise = null;
/**
 * This hook provides the current person, but only loads it once per application initialization to save
 * on HTTP requests and time.
 */
export const getSEOInfo = () => {
    if (!cachedInstitutionPromise) {
        cachedInstitutionPromise = SEOService.loadSEOInfo();
    }
    return cachedInstitutionPromise;
};
const useCachedLoadSEOInfo = () => getSEOInfo;
export default useCachedLoadSEOInfo;
